import { render, staticRenderFns } from "./TableShare.vue?vue&type=template&id=53acac18&scoped=true"
import script from "./TableShare.vue?vue&type=script&lang=js"
export * from "./TableShare.vue?vue&type=script&lang=js"
import style0 from "./TableShare.vue?vue&type=style&index=0&id=53acac18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53acac18",
  null
  
)

export default component.exports